import React from "react";

import FormDebito from "components/DebitoAutomatico/Form";
import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";
import TourBalloon from "components/NewTour/TourBallon";

import { useDebitoAutomaticoPage } from "../hooks/useDebitoAutomaticoPage";
import {
  Body,
  Container,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
} from "../styles";

const DebitoAutomaticoPage = (): JSX.Element => {
  const { showTour, tourStep, tourType } = useDebitoAutomaticoPage();

  return (
    <Navbar selected="debito-automatico" openSubMenu>
      <UserMenu intro />
      <Container
        showTour={
          tourStep === 1 && tourType === "debito-automatico" && showTour
        }
      >
        <Header>
          <HeaderInfos>
            <HeaderTitle>Débito automático</HeaderTitle>
            <HeaderSubtitle>
              Verifique seus dados de débito automático.
            </HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body>
          <FormDebito />
        </Body>
        {showTour && tourStep === 1 && tourType === "debito-automatico" && (
          <TourBalloon
            title="Débito Automático"
            content="Cadastre aqui sua conta em débito automático. Também é possível editar os dados bancários."
            position={{
              left: "482px",
              top: "45%",
              arrowPosition: "unset",
              maxWidth: 320,
              boxShadow: true,
            }}
          />
        )}
      </Container>
    </Navbar>
  );
};

export default DebitoAutomaticoPage;
